module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2d"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter1"
    }
  }), _c('span', [_vm._v("APHORISMS OF THE PROFESSOR.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2d1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO SERVE AS PROLEGOMENA TO HIS WORK AND ETERNAL BASIS TO THE SCIENCE.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" universe would be nothing were it not for life, and all that lives must be fed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("II. Animals fill themselves; man eats. The man of mind alone knows how to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("III. The destiny of nations depends on the manner in which they are fed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("IV. Tell me what kind of food you eat, and I will tell you what kind of man you are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("V. The Creator, when he obliges man to eat, invites him to do so by appetite, and rewards him by pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("VI. "), _c('i', [_vm._v("Gourmandise")]), _vm._v(" is an act of our judgment, in obedience to which, we grant a preference to things which are agreeable, over those which have not that quality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("VII. The pleasure of the table belongs to all ages, to all conditions, to all countries, and to all æras; it mingles with all other pleasures, and remains at last to console us for their departure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("VIII. The table is the only place where one does not suffer from "), _c('i', [_vm._v("ennui,")]), _vm._v(" during the first hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("IX. The discovery of a new dish confers more happiness on humanity, than the discovery of a new star.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("X. Those persons who suffer from indigestion, or who become drunk, are utterly ignorant of the true principles of eating and drinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XI. The order of food is from the most substantial to the lightest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XII. The order of drinking is from the mildest to the most foamy and perfumed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XIII. To say that we should not change our drinks is a heresy; the tongue becomes saturated, and after the third glass yields but an obtuse sensation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XIV. A dessert without cheese is like a beautiful woman who has lost an eye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XV. A cook may be taught, but a man who can roast, is born with the faculty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XVI. The most indispensable quality of a good cook is promptness. It should also be that of the guests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XVII. To wait too long for a dilatory guest, shows disrespect to those who are punctual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XVIII. He who receives friends and pays no attention to the repast prepared for them, is not fit to have friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("XIX. The mistress of the house should always be certain that the coffee be excellent; the master that his "), _c('i', [_vm._v("liquors")]), _vm._v(" be of the first quality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("XX. To invite a person to your house is to take charge of his happiness as long as he be beneath your roof.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b5dca5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter1.vue
// module id = 81
// module chunks = 0